import React from 'react';
import classnames from 'classnames';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { QuestionCircleOutlined } from '@ant-design/icons';

const parseRewardsBonusText = text => {
  if (text && text.indexOf('|') >= 0) {
    return (
      <ul style={{ marginLeft: 10 }}>
        {text.split('|').map((el, k) => (
          <li key={k}>
            <span
              dangerouslySetInnerHTML={{
                __html: el,
              }}
            />
          </li>
        ))}
      </ul>
    );
  } else {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      />
    );
  }
};

const GetTitle = ({ type, bonusTextLong, tooltipIcon, titleClass }) => {
  const showTooltip = bonusTextLong && bonusTextLong !== 'N/A';
  const tooltipTitle = parseRewardsBonusText(bonusTextLong);
  const Icon = tooltipIcon ?? QuestionCircleOutlined;
  return (
    <div className="bonusOfferBlockTitle">
      {showTooltip ? (
        <CSTooltip
          removeMargins
          title={tooltipTitle}
          isInline={true}
          className="marg0"
          datatestid="ccToolTip"
        >
          <div data-testid="bonusOfferTitle" className={titleClass}>
            {type + ' '}
            <Icon
              style={{
                display: 'inline-block',
                position: 'relative',
                top: -2,
              }}
            />
          </div>
        </CSTooltip>
      ) : (
        <div data-testid="bonusOfferTitle" className={titleClass}>
          {type}
        </div>
      )}
    </div>
  );
};

const BonusText = ({
  type,
  bonusTextShort,
  bonusTextLong,
  outerClass,
  innerTextClass,
  tooltipIcon,
  titleClass,
}) => {
  const wrapperClass = classnames('bonusOfferBlock', {
    [outerClass]: outerClass,
  });

  const textClass = classnames('bonusOffer', {
    [innerTextClass]: innerTextClass,
  });

  return (
    <>
      {bonusTextShort && (
        <div className={wrapperClass}>
          <GetTitle
            type={type}
            bonusTextLong={bonusTextLong}
            tooltipIcon={tooltipIcon}
            titleClass={titleClass}
          />
          <div
            className={textClass}
            dangerouslySetInnerHTML={{
              __html: bonusTextShort,
            }}
          ></div>
        </div>
      )}
    </>
  );
};

export default BonusText;
